import { render } from "./PieCharts.vue?vue&type=template&id=022bc0fa"
import script from "./js/pieCharts.js?vue&type=script&lang=js&external"
export * from "./js/pieCharts.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__